/**
 * Точка входа оверрайда ошибок валидации: ре-экспорт публичного API, назначение глобала и установка патча
 * прототипа Kendo при импорте (первой строкой `main.ts`).
 *
 * Патч привязан к именам методов прототипа (`validate`, `validateInput`) и к версии Kendo — константа
 * `KendoVersion` в `Common/Constants.cs`: при её изменении перепроверять оверрайд вызовом
 * `window.isValidationPopupOverrideInstalled()`.
 */

import { highlightFieldWithErrorByName } from './highlight';
import { installValidationPopupOverride, isValidationPopupOverrideInstalled } from './override';
import { normalizeValidationErrors, showValidationErrorsSafely } from './presenter';

export {
    highlightFieldWithErrorByName,
    normalizeValidationErrors,
    showValidationErrorsSafely
};

window.isValidationPopupOverrideInstalled = isValidationPopupOverrideInstalled;

/**
 * Установка на уровне модуля: оверрайд должен быть активен раньше, чем любой другой модуль приложения
 * создаст или провалидирует валидатор; если Kendo ещё не загружен — повтор по `$(document).ready`.
 */
const isInstalledOnLoad = installValidationPopupOverride();

if (!isInstalledOnLoad) {
    $(() => {
        installValidationPopupOverride();
    });
}
